import { IDialogProps } from 'Components/Core/Dialog/types';
import { actions as psdActions } from 'Data/ReduxViewModels/PsdSieveAnalysis';
import { Guid } from 'Lib/Guid';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { IWorksheetComponent } from '../../Core/types';

// Ideally we would use a regular ConfirmDialog but we want this dialog to stay up
// while the request is processing.
let RemoveSeparationDialog: React.FC<IWorksheetComponent & IDialogProps> = ({
  createWorksheetSelector,
  visible,
  onClose,
}) => {
  const dispatch = useDispatch();

  const separationId = useSelector(createWorksheetSelector!('Id')) as Guid;

  const [closeAfterRemoval, setCloseAfterRemoval] = useState(false);
  const removingSeparation = useSelector((state) => state.psdSieveAnalysis.separationManagement.status.removing);

  const removeSeparation = useCallback(() => {
    dispatch(psdActions.removeSeparation({ id: separationId }));
    setCloseAfterRemoval(true);
  }, [dispatch, separationId]);

  useEffect(() => {
    if (!removingSeparation && closeAfterRemoval) {
      setCloseAfterRemoval(false);
      if (visible) onClose?.();
    }
  }, [visible, removingSeparation, closeAfterRemoval, onClose]);

  return (
    <Dialog
      title="Remove Separation"
      buttons={[
        <Button
          error
          key="1"
          autoFocus
          onClick={removeSeparation}
          loading={removingSeparation}
          disabled={removingSeparation}
        >
          Remove Separation
        </Button>,
        <Button key="0" onClick={onClose as any} disabled={removingSeparation}>
          Cancel
        </Button>,
      ]}
      visible={visible}
      onClose={removingSeparation ? undefined : onClose}
      width="400px"
    >
      Are you sure you want to remove this separation? Data entered for this separation will be lost.
    </Dialog>
  );
};
RemoveSeparationDialog = withInjectedProps(RemoveSeparationDialog);

// Button to remove the separation at the path at which this button is added
let RemoveSeparationButton: React.FC<IWorksheetComponent> = () => {
  const [showRemoveSeparationDialog, setShowRemoveSeparationDialog] = useState(false);

  return (
    <>
      <Button onClick={() => setShowRemoveSeparationDialog(true)}>Remove Separation</Button>
      <RemoveSeparationDialog
        visible={showRemoveSeparationDialog}
        onClose={() => setShowRemoveSeparationDialog(false)}
      />
    </>
  );
};
RemoveSeparationButton = withInjectedProps(RemoveSeparationButton);

export { RemoveSeparationButton };
